import { Link, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import CustomModal from '../CustomModal'
import { ModalBody } from 'reactstrap'
import CancelModalButton from 'components/Custom/CancelModalButton'
import DeleteButton from 'components/Custom/DeleteButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'

const EditFile = (props) => {
  const file = props.content.find(
    (item) => item.id === parseInt(props.match.params.id)
  )
  let language = props.language || {}
  console.log(file.id, 'props.match.params.id')
  return (
    <div>
      <div className='row'>
        <div className='col-4'>
          <div className='upload-video-form-row'>
            <label>
              {language.settings ? language.settings.title : null}:{' '}
            </label>
            <input
              type='text'
              name='name'
              value={props.title ? props.title : ''}
              onChange={(event) => props.onChangeTitleText(event.target.value)}
            />
          </div>
        </div>
      </div>
      <div className='custom-control custom-checkbox-info mt-2'>
        <input
          className='custom-control-input'
          id='required_content'
          type='checkbox'
          checked={props.requiredContent}
          onChange={props.setRequired}
        />
        <label
          className='custom-control-label '
          htmlFor='required_content'
          style={{ fontSize: '14px', paddingTop: '2px' }}
        >
          {language?.courses?.required}
        </label>
      </div>
      <div className='row mt-5'>
        <div className='col-12'>
          <div className='upload-video-form-row'>
            <Link to={`/course/${props.id}/edit`}>
              <SubmitModalButton
                text={language?.general.submit}
                customFn={() => props.updateFileContent(file.id)}
              />
            </Link>
            <Link to={`/course/${props.id}/edit`}>
              <DeleteButton
                text={language.general.delete}
                customFn={() => props.deleteContent(file.id)}
              />
            </Link>
            <Link to={`/course/${props.id}/edit`}>
              <CancelModalButton text={language?.general.cancel} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

const ManageFile = (props) => {
  useEffect(() => {
    props.fetchTextContent(props.match.params.id)
  }, [])
  let language = props.language || {}
  return (
    <CustomModal
      courseId={props.course_id}
      // title={language.courses ? language.courses.edit_file : null}
      title='Edit File'
    >
      <ModalBody>
        <EditFile {...props} />
      </ModalBody>
    </CustomModal>
  )
}

export default ManageFile
